export const videoSlideHandler = (uniqueId, sliderHeight, setSliderHeight, mainImageClassName, thumbnailImageClassName) => {
  const videoSlides = [...document.querySelectorAll(`.image-gallery-wrapper[data-key="${uniqueId}"] .pdp--main-slider${mainImageClassName ? '.' + mainImageClassName : ''} .slick-slide:has(.video-slide)`)];
  const thumbnailSlider = document.querySelector(`.image-gallery-wrapper[data-key="${uniqueId}"] .pdp--thumbnail-slider${thumbnailImageClassName ? '.' + thumbnailImageClassName : ''}`);

  if (videoSlides.length > 0 && thumbnailSlider) {
    videoSlides.forEach(slide => {
      const hasActiveClass = slide.classList.contains('slick-active');

      if (hasActiveClass) {
        const slideHeight = slide?.offsetHeight;
        const thumbnailsHeight = thumbnailSlider?.offsetHeight;

        if (sliderHeight !== `${slideHeight + thumbnailsHeight}px`) {
          setSliderHeight(`${slideHeight + thumbnailsHeight}px`);
        }
      } else {
        if (sliderHeight !== 'inherit') {
          setSliderHeight('inherit');
        }
      }
    })
  }
  
  
};